import { atom, useRecoilState } from "recoil";
import axios from "axios";
import LanguageJSON from "../../utils/language.json";
import API from "../../utils/urls.utils";

const languageAtom = atom({
  key: "languageAtom",
  // default: null,
  default: LanguageJSON,
});

export default function useLanguage() {
  const [language, setLanguage] = useRecoilState(languageAtom);

  const fetchLanguage = async (lang, clientId) => {
    try {
      const { data } = await axios.post(API.HOST + API.LANGUAGE_KEYS, {
        clientId: clientId,
        languageCode: lang,
      });
      if (data.languageKeys) setLanguage(data.languageKeys);
      return data.languageKeys || language;
    } catch (err) {
      console.error(err);
    }
  };

  return { language, setLanguage, fetchLanguage };
}
